<template>
	<div>
		<v-row>
			<v-col cols="12" sm="8">
				<v-row class="mt-4" no-gutters>
					<v-col cols="12" sm="6">
						<v-text-field
							class="mx-1"
							v-model.trim="$v.form.name.$model"
							flat
							solo
							dense
							filled
							outlined
							autocomplete="off"
							label="Nombre*"
							hint="Ej: Minera los pelambres"
							:error-messages="nameErrors"
							@input="$v.form.name.$touch()"
							@blur="$v.form.name.$touch()"
						>
						</v-text-field>
					</v-col>
					<v-col cols="12" sm="6">
						<v-text-field
							class="mx-1"
							v-model.trim="$v.form.rut.$model"
							solo
							flat
							dense
							filled
							outlined
							autocomplete="off"
							label="RUT/Número/código*"
							hint="Ej: 11.111.111-3	"
							:error-messages="rutErrors"
							@input="$v.form.rut.$touch()"
							@blur="$v.form.rut.$touch()"
						></v-text-field>
					</v-col>
				</v-row>
				<v-row class="my-2" no-gutters>
					<v-col cols="12" sm="6">
						<v-text-field
							class="mx-1"
							v-model.trim="form.direction"
							flat
							solo
							dense
							filled
							outlined
							autocomplete="off"
							label="Direccion"
						>
						</v-text-field>
					</v-col>
					<v-col cols="12" sm="6">
						<v-text-field
							class="mx-1"
							v-model.trim="form.city"
							solo
							flat
							dense
							filled
							outlined
							autocomplete="off"
							label="Ciudad/comuna"
						></v-text-field>
					</v-col>
				</v-row>
				<v-row no-gutters>
					<v-col cols="12" sm="6">
						<v-text-field
							v-model.trim="formData.name"
							outlined
							dense
							filled
							class="mx-1"
							label="Servicio prestado*"
							hint="Ej: Alimentación"
							:disabled="loading"
							:error-messages="serviceErrors"
							@input="$v.formData.name.$touch()"
							@blur="$v.formData.name.$touch()"
						></v-text-field>
					</v-col>
					<v-col cols="12" sm="6">
						<v-text-field
							v-model="formData.price"
							type="number"
							outlined
							dense
							filled
							class="mx-1"
							:disabled="loading"
							label="Precio*"
							hint="Ej: 5600"
							:error-messages="priceErrors"
							@input="$v.formData.price.$touch()"
							@blur="$v.formData.price.$touch()"
						></v-text-field>
					</v-col>
				</v-row>
				<v-row no-gutters>
					<v-col cols="12" sm="6">
						<v-text-field
							v-model.trim="form.nombreCliente"
							outlined
							dense
							filled
							class="mx-1"
							label="Nombre Cliente"
							:disabled="loading"
							:error-messages="serviceErrors"
						></v-text-field>
					</v-col>
					<v-col cols="12" sm="6">
						<v-text-field
							v-model="form.rutCliente"
							outlined
							dense
							filled
							class="mx-1"
							:disabled="loading"
							label="Rut Cliente"
							:error-messages="priceErrors"
						></v-text-field>
					</v-col>
				</v-row>
				<v-row no-gutters>
					<v-col cols="12" sm="6">
						<v-text-field
							v-model.trim="form.nombreSolicitante"
							outlined
							dense
							filled
							class="mx-1"
							label="Nombre Solicitante"
							hint="Ej: Alimentación"
							:disabled="loading"
							:error-messages="serviceErrors"
						></v-text-field>
					</v-col>
					<v-col cols="12" sm="6">
						<v-text-field
							v-model="form.rutSolicitante"
							outlined
							dense
							filled
							class="mx-1"
							:disabled="loading"
							label="Rut Solicitante"
							:error-messages="priceErrors"
						></v-text-field>
					</v-col>
				</v-row>
				<v-row no-gutters>
					<v-col cols="12" sm="6">
						<v-text-field
							v-model.trim="form.telefonoGeneral"
							outlined
							dense
							filled
							class="mx-1"
							label="Telefono General"
							hint="Ej: Alimentación"
							:disabled="loading"
							:error-messages="serviceErrors"
						></v-text-field>
					</v-col>
				</v-row>

				<v-row class="my-2" no-gutters>
					<v-col cols="12" sm="6">
						<v-text-field
							class="mx-1"
							v-model="form.email[0]"
							flat
							solo
							dense
							filled
							outlined
							autocomplete="off"
							label="Correo Electronico"
						>
						</v-text-field>
					</v-col>
					<v-col cols="12" sm="6">
						<v-text-field
							class="mx-1"
							v-model="form.email[1]"
							solo
							flat
							dense
							filled
							outlined
							autocomplete="off"
							label="Correo Electronico"
						></v-text-field>
					</v-col>
				</v-row>
			</v-col>
			<v-col v-if="!$vuetify.breakpoint.smAndDown" sm="4">
				<v-img src="@/assets/lugares-1.png" max-width="200" />
			</v-col>
		</v-row>
		<v-row no-gutters justify="end">
			<v-col cols="4" sm="3">
				<v-btn
					block
					small
					:loading="loading"
					class="mb-2"
					color="success"
					@click="onSubmit"
				>
					<v-icon>mdi-content-save-outline</v-icon>
					Guardar
				</v-btn>
			</v-col>
			<v-btn class="ml-2" small color="warning" @click="helpPlace = !helpPlace">
				<v-icon small>mdi-help</v-icon>
			</v-btn>
		</v-row>
		<v-row>
			<v-expand-transition>
				<v-col cols="12" sm="10" xl="8" v-if="helpPlace">
					<div class="pointer" @click="helpPlace = !helpPlace">
						<empty
							:background-color="$vuetify.theme.isDark ? '#6a31ff17' : '#ded1ff7d'"
							font-color="#6A31FF"
							height="130"
							title="¿Qué es?"
							msj="Un Establecimiento es donde podrás planificar actividades de personas. Por ejemplo; Una faena, hotel, domicilio."
						/>
						<br />
						<empty
							:background-color="$vuetify.theme.isDark ? '#6a31ff17' : '#ded1ff7d'"
							font-color="#6A31FF"
							height="130"
							title="Caso especifico de ejemplo"
							msj="Podrías planificar 3 turnos para 20 personas en una construcción, ademas del servicio de cenas y entrega de EPP"
						/>
					</div>
				</v-col>
			</v-expand-transition>
		</v-row>
	</div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required, minLength, maxLength } from 'vuelidate/lib/validators';
import { mapActions, mapMutations } from 'vuex';

export default {
	mixins: [validationMixin],
	props: {
		close: {
			type: Function,
			default: null,
		},
	},
	components: {
		Empty: () => import('@/components/ui/DataEmpty'),
	},
	data() {
		return {
			helpPlace: false,
			loading: false,
			form: {
				name: '',
				rut: '',
				direction: '',
				city: '',
				services: [],
				email: [],
				nombreCliente: '',
				rutCliente: '',
				nombreSolicitante: '',
				rutSolicitante: '',
				telefonoGeneral: '',
			},
			formData: { name: '', price: '' },
		};
	},
	computed: {
		isPlaceRoute() {
			return this.$route.name == 'places';
		},
		nameErrors() {
			const errors = [];
			if (!this.$v.form.name.$dirty) return errors;
			!this.$v.form.name.required && errors.push('Campo requerido');
			!this.$v.form.name.minLength && errors.push('Minimo 3 Caracteres');
			!this.$v.form.name.maxLength && errors.push('Maximo 100 Caracteres');
			return errors;
		},
		rutErrors() {
			const errors = [];
			if (!this.$v.form.rut.$dirty) return errors;
			!this.$v.form.rut.required && errors.push('Campo requerido');
			return errors;
		},
		serviceErrors() {
			const errors = [];
			if (!this.$v.formData.name.$dirty) return errors;
			!this.$v.formData.name.required && errors.push('Campo requerido');
			!this.$v.formData.name.minLength && errors.push('Minimo 3 Caracteres');
			!this.$v.formData.name.maxLength && errors.push('Maximo 50 Caracteres');
			return errors;
		},
		priceErrors() {
			const errors = [];
			if (!this.$v.formData.price.$dirty) return errors;
			!this.$v.formData.price.required && errors.push('Campo requerido');
			this.formData.price.includes('.') && errors.push('No debe llevar puntos o coma');
			this.formData.price.includes(',') && errors.push('No debe llevar puntos o coma');
			return errors;
		},
	},
	methods: {
		async onSubmit() {
			this.$v.$touch();
			if (
				!this.$v.$invalid &&
				(!this.formData.price.includes('.') || this.formData.price.includes(','))
			) {
				this.loading = true;
				this.form.services.push(this.formData);
				await this.createPlace(this.form);
				await this.fetchPlace();
				this.setHasNewPlace();
				this.close();
				this.clearInputs();
				this.$v.$reset();
				this.loading = false;
				this.helpPlace = false;
			}
		},
		clearInputs() {
			this.form = {
				name: '',
				rut: '',
				direction: '',
				city: '',
				services: [],
				email: [],
			};
			this.formData = { name: '', price: '' };
			this.errors = false;
		},
		...mapActions({
			fetchPlace: 'Lodging/fetchPlace',
			createPlace: 'Place/createPlace',
		}),
		...mapMutations({
			setHasNewPlace: 'Place/setHasNewPlace',
		}),
	},
	validations: {
		form: {
			name: {
				required,
				minLength: minLength(3),
				maxLength: maxLength(100),
			},
			rut: {
				required,
			},
		},
		formData: {
			name: {
				required,
				minLength: minLength(3),
				maxLength: maxLength(50),
			},
			price: {
				required,
			},
		},
	},
};
</script>
